export default __webpack_public_path__ + "static/media/cards-generation.9ad5926f.png";